import type { Theme } from '@mui/material';

export const styles = {
  wrapper: (theme: Theme) => ({
    background: theme.palette.background.paper,
    borderRadius: '6px',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    direction: 'column',
    p: 2,
  }),
};
